import PortfolioConfigData from "config/portfolio-config.json";
import ComposizioneDelPortfolio from "./components/ComposizioneDelPortafoglio";
import React from "react";
import commonStyles from "pages/assistant/components/artifacts/components/fineco-portfolio/finecoPortfolio.common.module.scss";

type SectionChildrenProps = { reportData: any; reportData2?: any };
const ComposizioneDelPortafoglioContainer: React.FC<SectionChildrenProps> = ({
  reportData,
  reportData2,
}) => {
  if (!reportData) {
    return <></>;
  }

  return (
    <>
      <div
        className={commonStyles.sectionContainer}
        style={{ marginTop: reportData2 ? 28 : 0 }}
      >
        <h3 className={commonStyles.titleChart}>
          {PortfolioConfigData.portfolio.data.strumenti_fondi.label}{" "}
          {reportData2 && "1"}
        </h3>
        <ComposizioneDelPortfolio
          strumenti_fondi={reportData.portafoglio.strumenti_fondi}
          strumenti_obbligazionari={
            reportData.portafoglio.strumenti_obbligazionari
          }
        />
      </div>

      {reportData2 && (
        <>
          <div className="force-page-break"></div>
          <div
            className={commonStyles.sectionContainerComposizioneDelPortafoglio}
          >
            <h3 className={commonStyles.titleChart} style={{ marginTop: 40 }}>
              {PortfolioConfigData.portfolio.data.strumenti_fondi.label}
              {" 2"}
            </h3>
            <ComposizioneDelPortfolio
              strumenti_fondi={reportData2.portafoglio.strumenti_fondi}
              strumenti_obbligazionari={
                reportData2.portafoglio.strumenti_obbligazionari
              }
            />
            <div style={{ marginBottom: 20 }}></div>
          </div>
        </>
      )}
    </>
  );
};
export default React.memo(
  ComposizioneDelPortafoglioContainer,
  (prevProps: SectionChildrenProps, nextProps: SectionChildrenProps) => {
    // Custom comparison function
    return prevProps.reportData === nextProps.reportData;
  },
);
